/* eslint-disable react/display-name */
import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Button } from "@chakra-ui/react"
import { Link } from "react-router-dom"
import dayjs from "dayjs"
import { Button as AntdButton, Table } from "antd"
import { useTranslation } from "react-i18next"

import Layout from "../../components/layout/GeneralLayout"
import Alert from "../../components/common/Alert/AlertDialog"
import SpinnerLoading from "../../components/Loading/SpinnerLoading"
import * as actions from "../../redux/actions"

export default function Facility() {
  const facilities = useSelector((state) => state.facilities)
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [errMessage, setErrMessage] = useState()
  const [page, setPage] = useState(1)
  const [size, setSize] = useState(10)
  const dispatch = useDispatch()
  const { i18n } = useTranslation()

  useEffect(() => {
    dispatch(actions.getAllFacility(page))
      .then(() => {
        setIsLoading(true)
      })
      .catch((err) => {
        setErrMessage(err)
        setIsError(true)
      })
    return () => {}
  }, [page])

  if (isLoading === false) {
    return (
      <div>
        <Alert
          isError={isError}
          errMessage={errMessage}
          handleOnClose={() => {
            setIsError(false)
            setErrMessage()
          }}
        />
        <SpinnerLoading />
      </div>
    )
  }

  const handleDeleteFacility = (facilityId) => {
    const confirm = window.confirm("ยืนยันการลบสิ่งอำนวยความสะดวกนี้")
    if (confirm) {
      setIsLoading(false)
      dispatch(actions.deleteOneFacility(facilityId))
        .then(() => {
          dispatch(actions.getAllFacility())
            .then(() => {
              setIsLoading(true)
            })
            .catch((err) => {
              setErrMessage(err)
              setIsError(true)
            })
        })
        .catch((err) => {
          setErrMessage(err)
          setIsError(true)
        })
    }
  }

  const onChange = (pagination, filters, sorter, extra) => {
    const newPage = pagination?.current
    const pageSize = pagination?.pageSize
    setSize(pageSize)
    setPage(newPage)
    console.log("params", pagination, filters, sorter, extra)
  }

  const columns = [
    {
      title: "ลำดับที่",
      index: true,
      dataIndex: "index",
      render: (text, record, index) => (page - 1) * size + index + 1,
    },
    {
      title: "ชื่อ",
      dataIndex: "name",
      render: (text, record) => (
        <div>
          {record?.translation?.[i18n.language]?.name}
          <div className="flex gap-2">
            <Link to={`/site/facility/view/${record?.id}`} className=" hover:text-gray-600">
              <AntdButton size="small">รายละเอียด</AntdButton>
            </Link>
          </div>
        </div>
      ),
    },
    {
      title: "ช่วงเวลา",
      dataIndex: "category",
      render: (text, record) => (
        <div>
          {dayjs(record?.rangetime?.startdate).format("DD MMM YYYY")} -{" "}
          {dayjs(record?.rangetime?.enddate).format("DD MMM YYYY")}
        </div>
      ),
    },
    {
      title: "แก้ไขล่าสุด",
      dataIndex: "updatedAt",
      render: (text, record) => dayjs(record?.updatedAt).format("DD MMM YYYY HH:mm") || "-",
    },
    {
      title: "รายละเอียด",
      dataIndex: "active",
      render: (text, record) => (
        <div className="flex gap-2">
          <Link to={`/site/facility/edit/${record?.id}`}>
            <Button size="sm" colorScheme="yellow">
              แก้ไข
            </Button>
          </Link>
          <Button size="sm" colorScheme="red" onClick={() => handleDeleteFacility(record?.id)}>
            ลบ
          </Button>
        </div>
      ),
    },
  ]

  return (
    <Layout categoryTitle="จัดการเว็บไซต์โรงแรม" title="สิ่งอำนวยความสะดวก">
      <div className="flex justify-between px-4">
        <Link to="/site/facility/create">
          <Button colorScheme="purple">เพิ่ม</Button>
        </Link>
      </div>
      <div className="p-4 w-full overflow-x-auto">
        <Alert
          isError={isError}
          errMessage={errMessage}
          handleOnClose={() => {
            setIsError(false)
            setErrMessage()
          }}
        />
        {isLoading && (
          <Table
            columns={columns}
            dataSource={facilities?.arr}
            onChange={onChange}
            pagination={{
              current: page,
              pageSize: size,
              total: facilities?.total,
            }}
          />
        )}
      </div>
    </Layout>
  )
}
